import keycloak from '../keycloak';

const _kc = keycloak;

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
    _kc.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
            window.location.origin + '/silent-check-sso.html',
        pkceMethod: 'S256',
    })
        .then((authenticated) => {
            if (!authenticated) {
                console.log('user is not authenticated..!');
            }
            onAuthenticatedCallback();
        })
        .catch(console.error);
};

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const getRefreshToken = () => _kc.refreshToken;

const isLoggedIn = () => !!_kc.token;

const tokenParsed = () => _kc.tokenParsed;

const getUsername = () => _kc.tokenParsed?.preferred_username;

const getUi = () => _kc.tokenParsed?.ui;

const role = () => _kc.tokenParsed?.role;

const getName = () => _kc.tokenParsed?.name;

const getStartDate = () => _kc.tokenParsed?.package_start_date;

const getEndDate = () => _kc.tokenParsed?.package_end_date;

const getPermission = () => _kc.tokenParsed?.permission;

const permissions = () => {
    return _kc.tokenParsed?.permission?.split(',');
};

const currentPackage = () => {
    const packageMap = {
        //cookie management
        'e085db4ab26911ed867dfa163e89e3c8': 1,
        // PDPA starter
        'f44a99c6b26911ed867dfa163e89e3c8': 2,
        // PDPA Professional
        '0292fa41b26a11ed867dfa163e89e3c8': 3,
        // TEMP: cloned PDPA Professional package (same tier as above)
        'e2e7976abe1c11f195f506e246dac14e': 3,
        // PDPA Enterprise
        '0fd87d26b26a11ed867dfa163e89e3c8': 4,
    };
    return packageMap[_kc.tokenParsed?.current_package_id] || 0;
};

const UserService = {
    initKeycloak,
    doLogin,
    doLogout,
    isLoggedIn,
    getToken,
    getRefreshToken,
    currentPackage,
    getUsername,
    getUi,
    tokenParsed,
    role,
    getName,
    getStartDate,
    getEndDate,
    getPermission,
    permissions,
};

export default UserService;
